<form>
	<table bpHl="Vegetationsaufnahme" [hldata]="bp" class="table table-sm table-striped table-hover no-bottom-margin tborder lborder rborder bborder" [ngClass]="{ 'bp-print-view': printView}">
		<tbody>
			<tr>
				<!-- <th colspan="1">Beschr.</th> -->
				<th colspan="9" class="w-100">Schichtanteile</th>
			</tr>
			<tr>
				<td colspan="9" class="w-100 schicht-row">
					<div class="schicht-summaries">
						<div *ngFor="let sch of schichten()" class="schicht-summary">
							<span class="schicht-label">{{schichtLabel(sch)}}</span>
							<span class="schicht-value">{{bp.bodenvegetation.aufnahme.schichtAnteile[sch] ?? '–'}}</span>
						</div>
					</div>
				</td>
			</tr>
			<tr>
				<th colspan="1">Schicht</th>
				<th colspan="7" class="w-75">Vegetation</th>
				<th class="w-25 text-right">%</th>
			</tr>
			<tr *ngFor="let row of sortedVegetationen(); let i = index">
				<td colspan="1"><wd-list name="Vegetationsschicht" [(model)]="row.schicht"></wd-list></td>
				<td colspan="7" class="w-75">
					<wd-list name="Vegetation" [(model)]="row.vegetation" placement="bottom-left bottom-right top-left top-right"></wd-list>
				</td>
				<td><wd-text name="Vegetations-Anteil[{{i}}]" class="w-25 text-right" [(model)]="row.haeufigkeit"></wd-text></td>
			</tr>
			<tr *ngIf="bp.bodenvegetation.aufnahme.vegetationen.length === 0">
				<td></td>
				<td [attr.colspan]="7"><i class="bi bi-plus"></i></td>
				<td></td>
			</tr>
			<tr class="spacer-row"><td colspan="9"></td></tr>
		</tbody>
	</table>
	<table *ngIf="!printView" class="table table-sm table-dark no-bottom-margin" [ngClass]="{ 'bp-print-view': printView}">
		<tbody>
			<tr bpHl="Vegetationsaufnahme" [hldata]="bp" class="tborder lborder rborder">
				<th colspan="2">{{humusformLabel(bp)}}</th>
				<th colspan="7">Humusauflage</th>
			</tr>
			<tr bpHl="Vegetationsaufnahme" [hldata]="bp" class="lborder rborder">
				@if (hatHumusForm(bp) && hatVegetationsformengruppe(bp)) {
					<td colspan="1"><wd-an-list [horizontal]="false" name="Humusform" [(model)]="bp.header.humusform.aufnahmeFlaeche"></wd-an-list></td>
					<td colspan="1"><wd-list name="Vegetationsformengruppe" [(model)]="bp.header.vegetationsformengruppe"></wd-list></td>
				}
				@else if (hatHumusForm(bp)) {
					<td colspan="2"><wd-an-list [horizontal]="false" name="Humusform" [(model)]="bp.header.humusform.aufnahmeFlaeche"></wd-an-list></td>
				}
				@else if (hatVegetationsformengruppe(bp)) {
					<td colspan="2"><wd-list name="Vegetationsformengruppe" [(model)]="bp.header.vegetationsformengruppe"></wd-list></td>
				}
				@else {
					<td colspan="2">-</td>
				}
				<th colspan="1">Ol</th>
				<td colspan="1"><wd-number name="Ol" [(model)]="bp.extendedHeader.humusAuflage.ol"></wd-number></td>
				<th colspan="1">Of</th>
				<td colspan="1"><wd-number name="Of" [(model)]="bp.extendedHeader.humusAuflage.of"></wd-number></td>
				<th colspan="1">Oh</th>
				<td colspan="1"><wd-number name="Oh" [(model)]="bp.extendedHeader.humusAuflage.oh"></wd-number></td>
				<th></th>
			</tr>
			<!-- Leerzeile vor Bestand/Bemerkungen -->
			<tr class="spacer-row-sm"><td colspan="9"></td></tr>
			<tr bpHl="Vegetationsaufnahme" [hldata]="bp" class="lborder rborder">
				<th>Bestand</th>
				<td colspan="8"><span class="cell-text">{{baumarten()}}</span></td>
			</tr>
			<tr bpHl="Vegetationsaufnahme" [hldata]="bp" class="lborder rborder bborder">
				<th>Bemerkungen</th>
				<td colspan="8"><span class="cell-text">{{bp.header.bemerkungen}}</span></td>
			</tr>
		</tbody>
	</table>
</form>
